// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"8":"custom-forms","42":"modal","90":"add-to-homescreen","162":"pdp-components","612":"youtube-player","797":"npm.vue-custom-scrollbar"}[chunkId] || chunkId) + "." + {"8":"9fb750b7","42":"6d3ea3c0","90":"de404d09","162":"fafb9df5","210":"e27114ab","612":"90201e3d","797":"64d4cca4"}[chunkId] + ".js";
};